import ccEmail from '@/api/cc_emails'

export default ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    ccEmail.setCcEmail(result => {
      resolve(result.data.data)
    }, param)
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/cc_emails/actions/setCcEmail.js